<template>
    <article :class="accordionClasses" class="message">
        <p>By Submitting this request you declare that you are familiar with our <a href="#" @click.stop.prevent="toggleAccordion"
                                                          class="gdpr message-header"> HR Personal data policy</a></p>

        <div class="textarea--wrapper" :class="{'is-opened':isOpen}">
            <div class="paragraph--frame">
                <h4>HR Personal Data Policy</h4>
                <ol class="gdpr-rules">
                    <li>According to respective provisions of General Data Protection Regulation (“GDPR”) we, BOHEMIA
                        INTERACTIVE a.s., ID No: 272 18 864, having its registered office at Stříbrná Lhota 747, Mníšek
                        pod Brdy 252 10 as the data controller (the “Controller”), hereby inform you how we process your
                        personal data you give us by your application for a position in our company.
                    </li>
                    <li>We process your personal data contained in your CV for purposes of proper selection of
                        candidates for our vacant positions. Information you filled during your application (your email
                        address, name and phone number) are processed for purposes of communication with you. Personal
                        data contained in your CV is processed based on our legitimate interest to choose the most
                        suitable candidates. Your email address, name and phone number are processed based on our
                        legitimate interest to be able to communicate with you.
                    </li>
                    <li>We process your personal data contained in your CV for purposes of negotiations with you
                        prior to the eventual entering into a contract.
                    </li>
                    <li>If you give us a consent to keep your CV and email address, name and telephone number we also
                        process and keep such personal data for the purposes of record keeping of job applicants for
                        eventual offering a job to such applicants in the future. In this case we will keep your CV and
                        personal data you filled during your application for 2 years from the date such consent was
                        given.
                    </li>
                    <li>
                        Your consent may be withdrawn at any time by contacting us at dataprotection@bohemia.net.
                    </li>
                    <li>If you do not give us a consent according to Sec. 4 or withdraw your consent according to
                        Sec. 5. of this policy we will process and keep your personal information only during the
                        process of evaluation of the most suitable candidate for the position you applied for and we
                        will not continue to process your personal data after the selection process is closed.
                    </li>
                    <li>According to GDPR you have the following rights: right to request from the Controller an
                        access to and rectification or erasure of your personal data, right to restriction of processing
                        of your personal data, right to portability of your personal data and right to object processing
                        of your personal data.
                    </li>
                    <li>If you feel your personal data is not processed in compliance with GDPR you have the right to
                        lodge a complaint to the supervisory authority in the country where you live, work or where the
                        infringement of rights took place. In the case of the Czech Republic the supervisory authority
                        is: The Office for Personal Data Protection, address: Pplk. Sochora 27, 170 00 Praha 7, Czech
                        Republic.
                    </li>
                    <li>If you wish to exercise any of your rights arising out of Sec. 7. of this policy please
                        contact us at dataprotection@bohemia.net.
                    </li>
                </ol>
            </div>

        </div>
    </article>
</template>

<script>
    export default {
        name: "Accordion",
        data() {
            return {
                isOpen: false
            }
        },
        methods: {
            toggleAccordion: function () {
                this.isOpen = !this.isOpen;
            }
        },
        computed: {
            accordionClasses: function () {
                return {
                    'is-closed': !this.isOpen,
                    'is-primary': this.isOpen,
                    'is-dark': !this.isOpen
                };
            }
        }
    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/globals";

    .gdpr {
        font-family: $font-paragraphs;
        text-decoration: underline;
        color: gray;
    }

    .gdpr-rules{
        li{
            padding-bottom: 10px;
            padding-top: 10px;
            color: #1a1a1a;
            font-family: "Inter UI",sans-serif;
            letter-spacing: 0.02px;
            line-height: 26px;
        }
    }
    .message-header {
        cursor: pointer;
    }

    .message-body {
        padding: 0;
        max-height: 10em;
        overflow: hidden;
        transition: 0.3s ease all;
    }

    .message-content {
        padding: 20px;
    }

    .textarea--wrapper {
        border: 1px solid #444444;
        border-radius: 4px;
        overflow-y: scroll;
        max-height: 0;
        visibility: hidden;
        transition: all 0.4s ease-out;
        &.is-opened {
            max-height: 300px;
            visibility: visible;
        }
    }

    .paragraph--frame {
        padding: 2em;
    }

</style>


// WEBPACK FOOTER //
// src/components/common/Accordion.vue